import script from "./inquiry_check.vue?vue&type=script&setup=true&lang=ts"
export * from "./inquiry_check.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__